const DEBUG_STORAGE_KEY = 'e2eeDebugSettings'

function loadDebugSettings() {
  try {
    let raw = localStorage.getItem(DEBUG_STORAGE_KEY)
    if(raw) {
      let parsed = JSON.parse(raw)
      return {
        enabled: !!parsed.enabled,
        delayMs: Number(parsed.delayMs) || 0,
        forceFail: !!parsed.forceFail
      }
    }
  } catch(e) {
    console.log(e)
  }
  return { enabled: false, delayMs: 0, forceFail: false }
}

class E2EEStatus {
  constructor() {
    this.hasIssue = false
    this.lastContext = null
    this.onConnectionIssue = null
    this.onConnectionRestored = null
    this.debug = loadDebugSettings()
  }

  setDebug(settings) {
    this.debug = {
      enabled: !!settings.enabled,
      delayMs: Number(settings.delayMs) || 0,
      forceFail: !!settings.forceFail
    }
    try {
      localStorage.setItem(DEBUG_STORAGE_KEY, JSON.stringify(this.debug))
    } catch(e) {
      console.log(e)
    }
  }

  getDebug() {
    return { ...this.debug }
  }

  reportConnectionIssue(context) {
    console.log('E2EEStatus: connection issue - ' + context)
    this.lastContext = context
    if(!this.hasIssue) {
      this.hasIssue = true
      if(this.onConnectionIssue) {
        try {
          this.onConnectionIssue(context)
        } catch(e) {
          console.log(e)
        }
      }
    }
  }

  reportSuccess() {
    if(this.hasIssue) {
      this.hasIssue = false
      this.lastContext = null
      if(this.onConnectionRestored) {
        try {
          this.onConnectionRestored()
        } catch(e) {
          console.log(e)
        }
      }
    }
  }

  withSlowWarning(promise, thresholdMs, label) {
    let wrapped = promise
    if(this.debug.enabled) {
      const delayMs = this.debug.delayMs
      const forceFail = this.debug.forceFail
      if(delayMs > 0 || forceFail) {
        wrapped = new Promise((resolve, reject) => {
          setTimeout(() => {
            if(forceFail) {
              const err = new Error(`E2EE debug forced failure: ${label}`)
              err.isE2EEDebugForcedFailure = true
              reject(err)
              return
            }
            promise.then(resolve, reject)
          }, Math.max(0, delayMs))
        })
      }
    }

    const timer = setTimeout(() => {
      this.reportConnectionIssue(`${label}: failed to connect for ${thresholdMs}ms`)
    }, thresholdMs)

    return wrapped.then(
      val => {
        clearTimeout(timer)
        return val
      },
      err => {
        clearTimeout(timer)
        throw err
      }
    )
  }

}

export default (new E2EEStatus())
